/**
 * Production builds manually create and inject an env.js in /public
 */
if (process.env.NODE_ENV !== "production") {
  require("./env.js");
}

const { initTealium, updateTealiumPage } = require("./utils/tealium");

const initOneTrust = () => {
  if (!document || typeof window?._env_?.ONE_TRUST_ID === "undefined") return;

  const script = document.createElement("script");
  script.src = "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js";
  script.type = "text/javascript";
  script.async = true;
  script.setAttribute("data-domain-script", window._env_.ONE_TRUST_ID);
  document.body.appendChild(script);

  const scriptFn = document.createElement("script");
  scriptFn.type = "text/javascript";
  scriptFn.innerHTML = "function OptanonWrapper() { }";
  document.body.appendChild(scriptFn);
};

exports.onClientEntry = () => {
  if (process.env.GATSBY_TEALIUM_TAG_ID) {
    initTealium();
  }
  initOneTrust();
};

exports.onRouteUpdate = ({ location }) => {
  updateTealiumPage(location);
};
